import axios from "axios";

export const axiosLoginInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});

export default axiosInstance;

export const axiosInstancePayment = axios.create({
  baseURL: `${process.env.REACT_APP_PAYMENT_URL}`,
});

export const axiosInstancePaymentIframe = axios.create({
  baseURL: `${process.env.REACT_APP_PAYMENT_URL_IFRAME}`,
});

export const axiosInstanceAppToken = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL_GET_TOKEN}`,
});
export const axiosRelayInstance = axios.create({
  baseURL: `${process.env.REACT_RELAY_API_URL}`,
});
export const axiosRegisterInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});
export const axiosEnrollmentAppApi = axios.create({
  baseURL: `${process.env.REACT_APP_ENROLL_API_URL}`,
});
